export type CartProduct = {
  slug: string;
  name: string;
  price: number;
  imageLabel: string;
  shortDescription?: string;
  variantId?: string;
  variantName?: string;
  variantSku?: string;
  variantDescription?: string;
};

export type CartItem = CartProduct & {
  quantity: number;
};

export const CART_STORAGE_KEY = "abv-labs-cart";

export function getCartTotal(items: CartItem[]) {
  return items.reduce((total, item) => total + item.price * item.quantity, 0);
}


export function cartItemKey(item: Pick<CartItem, "slug" | "variantSku">) {
  return item.slug + "::" + (item.variantSku ?? "base");
}
